/* eslint-disable no-undef */
import config from '../../../config';

export function initLogging() {
    if (config.logging.loglevel) {
        // @ts-expect-error TS(2304): Cannot find name 'log'.
        log.enableAll();
    } else {
        // @ts-expect-error TS(2304): Cannot find name 'log'.
        log.disableAll();
    }
}
